<template lang="html">
  <div class="contentsection">
        <div class="row">
          <div class="col-6 heightborder">
            <div class="dropdown-block"
            v-if="[utilizationStatus.APPROVED, utilizationStatus.PROCESSING]
              .includes(truckUtilizationDetails.approval_status)">
              <div class="dd-header">{{$t('INDENT_VEHICLE_CHANGED_TO')}}</div>
              <ul class="listblock">
                <li class="msgblock">{{requestedVehicle.name}}</li>
              </ul>
            </div>
        <RadioGroup v-model="changeTruck" @change="switchOption"
        v-if="[utilizationStatus.PENDING, utilizationStatus.REJECTED]
          .includes(truckUtilizationDetails.approval_status)">
        <div class="col-12 no-padding">
          <Radio :label="true">{{$t('INDENT_CONTINUE_SAME_VEHICLE')}}</Radio>
            <div class="dropdown-block spacingblock">
          </div>
        </div>
        <div class="col-12 no-padding">
          <Radio :label="false">{{$t('INDENT_CHANGE_VEHICLE_TYPE')}}</Radio>
          <div class="dropdown-block spacingblock" v-if="!changeTruck">
            <div class="dd-header">{{$t('INDENT_CHANGE_VEHICLE_TYPE')}}</div>
            <div class="dropdown-section">
              <Select v-model="truckChange"
              placeholder="Select"
              @change="onChange">
              <Option
                v-for="vehicleType in truckUtilizationDetails.vehicle_types"
                :key="vehicleType.id"
                :label="vehicleType.name"
                :value="vehicleType.id">
                </Option>
              </Select>
          </div>
        </div>
        </div>
        </RadioGroup>
      </div>
      <div class="col-6">
        <div class="dropdown-block">
        <div class="dd-header">{{$t('INDENT_VEHICLE_CHANGES')}}</div>
        <ul class="listblock">
          <li>{{vehicleDetails.name}}</li>
          <li>{{vehicleDetails.kg}} KG</li>
          <li>{{vehicleDetails.cft}} CFT ({{convertToCMT(vehicleDetails.cft)}} CMT)</li>
        </ul>
      </div>

      <div class="dropdown-block">
      <div class="dd-header">{{$t('INDENT_MATERIAL_DETAILS')}}</div>
      <ul class="listblock">
        <li>{{truckUtilizationDetails.total_materials.weight}} KG </li>
        <li>{{truckUtilizationDetails.total_materials.volume}} CFT ({{convertToCMT(truckUtilizationDetails.total_materials.volume)}} CMT)</li>
      </ul>
    </div>
    <div class="dropdown-block">
    <div class="dd-header inlinefloat">{{$t('INDENT_UTILIZATION')}}</div>
      <div id="crumbs">
        <ul>
          <li class="badge-spaced">
            <a
              href="#"
              :class="(requestForApproval.mode !== 'utilized') ? 'high': 'sucess'">
              {{requestForApproval.mode}}
            </a>
          </li>
        </ul>
      </div>
    <ul class="listblock">
      <li>Weight  - {{utilization.utilWeight}}% </li>
      <li>Volume - {{utilization.utilVolume}}%</li>
    </ul>
  </div>
      </div>
    </div>
    <div class="commenttimeline">
      <div v-for="(comment,index) in truckUtilizationDetails.comments" :key="index">
        <div class="commenttimeline_title"><b>{{comment.user.name}}</b> </div>
        <div class="commenttimeline_date">
          {{comment.create_at | moment("DD MMM YYYY | hh:mm A")}}
        </div>
        <p class="commenttimeline_content">{{comment.message}}</p>
      </div>
      <textarea rows="5" v-model="comments" placeholder="Add reason"></textarea>
    </div>
    <div class="popupsubmit">

      <button
        class="btn btn-secondary"
        v-if="isRequiredApproval"
        @click="sendStatus(utilizationStatus.REJECTED)"
      >
        {{$t('INDENT_REJECT')}}
      </button>
      <button
        class="btn btn-primary"
        v-if="isRequiredApproval"
        @click="sendStatus(utilizationStatus.APPROVED)"
      >
        {{$t('INDENT_APPROVE')}}
      </button>

      <button class="btn btn-primary"
        v-if="hasRequestPermission"
        @click="sendRequest"
      >
        {{$t('INDENT_SEND')}}
      </button>
      <button
        class="btn btn-primary"
        v-if="hasTruckUpdatePermission && !isRequiredApproval"
        @click="updateTruck(utilizationStatus.APPROVED)"
      >
        {{$t('INDENT_UPDATE')}}
      </button>
    </div>
  </div>
</template>
<script>
import { cmtValue } from '@/constants/order';

export default {
  props: [
    'order',
    'truckUtilizationDetails',
    'getMovemntsTypes',
    'utilizationStatus',
    'movement',
  ],

  data() {
    return {
      changeTruck: true,
      vehicleDetails: {},
      truckChange: '',
      selectRole: '',
      comments: '',
      cmtValue,
    };
  },

  created() {
    this.vehicleDetails = this.order.vehicle_type;
  },

  computed: {
    currentOrderMovement() {
      if (this.order.movement === this.getMovemntsTypes.RETURNS) {
        return 'returns';
      } else if (this.order.movement === this.getMovemntsTypes.INWARD) {
        return 'inward';
      } else if (this.order.movement === this.getMovemntsTypes.PRIMARY) {
        return 'primary';
      }
      return 'secondary';
    },
    utilization() {
      const { total_materials: totalMaterial } = this.truckUtilizationDetails;
      console.log(totalMaterial);
      const materialWeight = totalMaterial.weight ? totalMaterial.weight : 0;
      const materialVolume = totalMaterial.volume ? totalMaterial.volume : 0;

      const weightOfVehicle = this.vehicleDetails.kg;
      const volumeOfVehicle = this.vehicleDetails.cft;

      const utilWeightPercentage =
        (materialWeight / weightOfVehicle) * 100 || 0;
      const utilVolumePercentage =
        (materialVolume / volumeOfVehicle) * 100 || 0;
      return {
        utilWeight: parseFloat(utilWeightPercentage.toFixed(2)),
        utilVolume: parseFloat(utilVolumePercentage.toFixed(2)),
      };
    },
    requestForApproval() {
      const { utilWeight, utilVolume } = this.utilization;
      const {
        meta: { utilization_threshold: utilizationThreshold },
      } = this.truckUtilizationDetails;
      const {
        weight_lower: weightMin,
        weight_upper: weightMax,
        volume_lower: volumeMin,
        volume_upper: volumeMax,
      } = utilizationThreshold[this.currentOrderMovement];
      return this.checkApprovalStatus(
        { weightMin, weightMax, volumeMin, volumeMax },
        { utilWeight, utilVolume },
      );
    },
    requestedVehicle() {
      return this.truckUtilizationDetails.vehile_details || {};
    },
    hasRequestPermission() {
      if (
        [
          this.utilizationStatus.PENDING,
          this.utilizationStatus.REJECTED,
        ].includes(this.truckUtilizationDetails.approval_status)
      ) {
        return (
          this.requestForApproval.needApproval === true &&
          this.$hasPermission('request_vehicle_utilization')
        );
      }
      return false;
    },
    hasTruckUpdatePermission() {
      if (
        [
          this.utilizationStatus.PENDING,
          this.utilizationStatus.REJECTED,
        ].includes(this.truckUtilizationDetails.approval_status)
      ) {
        return (
          this.requestForApproval.needApproval === false &&
          this.$hasPermission('update_vehicle_utilization')
        );
      }
      return true;
    },
    isRequiredApproval() {
      return (
        this.truckUtilizationDetails.approval_status ===
          this.utilizationStatus.PROCESSING &&
        this.$hasPermission('approve_vehicle_utilization')
      );
    },
    isSameVehicleType() {
      if (this.requestedVehicle.id) {
        return this.requestedVehicle.id === this.order.vehicle_type.id;
      }
      return this.changeTruck;
    },
    getVehicleId() {
      if (
        this.utilizationStatus.PENDING ===
        this.truckUtilizationDetails.approval_status
      ) {
        return this.vehicleDetails.id;
      }
      return this.requestedVehicle.id;
    },
  },
  methods: {
    convertToCMT(cft) {
      return (cft && cft / this.cmtValue).toFixed(2) || 0;
    },
    onChange(selectedId) {
      const vehicle = this.truckUtilizationDetails.vehicle_types.find(
        _vehicle => _vehicle.id === selectedId,
      );
      this.vehicleDetails = vehicle;
    },
    async sendRequest() {
      try {
        const data = {
          same_vehicle: this.changeTruck,
          vehicle_type_id: this.vehicleDetails.id,
          approval_status: this.utilizationStatus.PROCESSING,
          comments: this.comments,
        };

        if (!data.same_vehicle && !this.truckChange) {
          this.$error({ message: 'Please select vehicle type' });
        } else {
          const result = await this.$store.dispatch('order/sendForApproval', {
            orderNo: this.order.order_number,
            data,
          });
          this.$emit('done', 'truckUtilization');
          this.$success({
            message: this.$t('INDENT_UTILIZATION_SUCCESS_MSG', { order_number: result.order_number }),
          });
        }
      } catch (error) {
        this.$error({ message: this.$t('INDENT_UNABLE_PROCESS_ERROR_MSG') });
      }
    },
    switchOption() {
      if (this.changeTruck) {
        this.vehicleDetails = this.order.vehicle_type;
      } else {
        this.truckChange = '';
      }
    },
    checkApprovalStatus(
      { weightMin, weightMax, volumeMin, volumeMax },
      utilization = {},
    ) {
      const { truckUtilization } = this.$pandoConstants;
      const weightCheckThreshold = this.compareWithThreshold(
        weightMin,
        weightMax,
        utilization.utilWeight,
      );
      const volumeCheckThreshold = this.compareWithThreshold(
        volumeMin,
        volumeMax,
        utilization.utilVolume,
      );
      const {
        meta: { truck_utilization: truckUtilizationMode },
      } = this.truckUtilizationDetails;
      switch (truckUtilizationMode) {
        case truckUtilization.WEIGHT:
          return weightCheckThreshold;
        case truckUtilization.VOLUME:
          return volumeCheckThreshold;
        case truckUtilization.WEIGHTANDVOLUME:
          return weightCheckThreshold.needApproval &&
            volumeCheckThreshold.needApproval
            ? { mode: 'check', needApproval: true }
            : { mode: 'utilized', needApproval: false };
        case truckUtilization.WEIGHTORVOLUME:
          return weightCheckThreshold.needApproval ||
              volumeCheckThreshold.needApproval
            ? { mode: 'check', needApproval: true }
            : { mode: 'utilized', needApproval: false };
        default:
          return null;
      }
    },

    compareWithThreshold(minValue, maxValue, value) {
      const approvalJson = {
        mode: 'utilized',
        needApproval: false,
      };
      if (value < minValue) {
        approvalJson.mode = 'low';
        approvalJson.needApproval = true;
      } else if (value > maxValue) {
        approvalJson.mode = 'high';
        approvalJson.needApproval = true;
      }
      return approvalJson;
    },
    async sendStatus(approvalStatus) {
      try {
        const data = {
          same_vehicle: this.isSameVehicleType,
          vehicle_type_id: this.getVehicleId,
          approval_status: approvalStatus,
          comments: this.comments,
        };
        const result = await this.$store.dispatch('order/sendStatus', {
          orderNo: this.order.order_number,
          data,
        });
        const message =
          approvalStatus === this.utilizationStatus.APPROVED
            ? 'approved'
            : 'rejected';
        this.$emit('done', 'truckUtilization');
        this.$success({
          message: this.$t('INDENT_UTILIZATION_SENT_SUCCESS_MSG', { message, order_number: result.order_number }),
        });
      } catch (error) {
        this.$error({ message: this.$t('INDENT_UNABLE_PROCESS_ERROR_MSG') });
      }
    },
    async updateTruck(approvalStatus) {
      try {
        const data = {
          same_vehicle: this.changeTruck,
          vehicle_type_id: this.vehicleDetails.id,
          approval_status: approvalStatus,
          comments: this.comments,
        };
        const result = await this.$store.dispatch('order/updateTruck', {
          orderNo: this.order.order_number,
          data,
        });
        this.$emit('done', 'truckUtilization');
        this.$success({
          message: this.$t('INDENT_UTILIZATION_UPDATE_SUCCESS_MSG', { order_number: result.order_number }),
        });
      } catch (error) {
        this.$error({ message: this.$t('INDENT_UNABLE_PROCESS_ERROR_MSG') });
      }
    },
  },
};
</script>
<style lang="scss">
@import "~@common/styles-shipper/settings";

.chkbox-group {
  margin: 20px 0;
  &-title {
    font-size: 1.2rem;
    margin: 0 0 10px 0;
  }
  .chkbox-item {
    display: inline-block;
    margin-right: 15px;
    margin-bottom: 10px;
    width: 100px;
    label {
      font-family: $fontSemibold;
      font-size: 1.2rem;
      padding-left: 3px;
      cursor: pointer;
    }
  }
}
.card-view {
  margin: 20px 0;
  .image-upload {
    .image-upload-header {
      .image-upload-title {
        font-size: 1.2rem;
        margin: 0 0 20px 0;
        color: $sec-text;
        display: inline-block;
      }
      .upload-option {
        padding: 0 0 0 10px;
        display: inline-block;
        &-text {
          color: #5596b9;
          font-size: 1.2rem;
          padding: 0 5px 0 10px;
        }
      }
    }
    .image-upload-content {
      .photo-upload {
        border: 1px solid #d7d7d7;
        width: 71px;
        height: 71px;
        margin: 0 20px 0 0;
        display: inline-block;
      }
    }
  }
}
.submit-button {
  //float: right;
  margin: 20px 0 0 0;
  .primary-button {
    @extend %primary-btn;
    text-transform: uppercase;
    .btn-text {
      color: $primary-text;
      text-transform: uppercase;
    }
  }
}
.datepicker {
  .datepicker-title {
    font-size: 1.2rem;
    margin: 0 0 10px 0;
    color: $sec-text;
  }
  .mx-input {
    border-bottom: 1px solid #ccc;
    border-radius: 0;
    box-shadow: none;
    border-top: 1px solid transparent;
    border-right: 1px solid transparent;
    border-left: 1px solid transparent;
    padding: 6px 30px 6px 0px;
  }
  .mx-datepicker {
    color: $sec-text;
    &-popup {
      left: 0px;
    }
  }
  .mx-time-item {
    &.cur-time {
      background-color: #f0f0f0;
      color: $sec-text;
    }
    &:hover {
      background-color: #f0f0f0;
    }
  }
  .mx-calendar {
    padding: 2px 0px;
    thead {
      border-bottom: 1px solid #ced1d2;
    }
    td,
    th {
      text-transform: capitalize;
      font-weight: normal;
      width: 30px;
      height: 30px;
      text-align: center;
      font-size: 12px;
    }
    &-header {
      text-transform: capitalize;
      color: $primary-text;
      font-family: $fontSemibold;
      a:hover {
        color: #244357;
      }
    }
    &-content {
      height: 210px;
    }
    &-month > a.current,
    &-table td.current,
    &-year > a.current {
      background-color: #f0f0f0;
      color: $sec-text;
    }
    &-month > a:hover,
    &-table td.inrange,
    &-table td:hover,
    &-year > a:hover {
      background-color: #f0f0f0;
    }
  }
}
</style>
